module.exports = __webpack_public_path__ + "img/ai-compare-history-chevron-left.0c9872c3.svg";